import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2D1 } from '../../../../../../../redux/app/annex6-v2/groups/group-d';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupD1PreviewProps = OwnProps;

function Annex6V2GroupD1Preview(props: Annex6V2GroupD1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2D1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );

    function renderMain() {
        const tableRows = [
            [operationDate, 'D', '1', renderItem1()],
            [null, null, '2', renderItem2()],
            [null, null, '3', renderItem3()],
            [null, null, '6', renderItem6()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItem1() {
        return (
            <h4 className="font-medium uppercase">
                {record.item1.place === 'AT_SEA'
                    ? `LATITUDE: ${record.item1.latitude}, LONGITUDE: ${record.item1.longitude}`
                    : `PORT: ${record.item1.portName}, BERTH: ${record.item1.berth}`}
            </h4>
        );
    }

    function renderItem2() {
        const { date: smtDate, time: smtTime } = record.item2;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Arrived at Berth on {utcTime.format('HH:mm')} hrs UTC on{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')})
            </h4>
        );
    }

    function renderItem3() {
        const { start, end } = record.item3;
        const startDate = moment(start.date, 'YYYY-MM-DD').format(
            'DD-MMM-YYYY'
        );
        const endDate = moment(end.date, 'YYYY-MM-DD').format('DD-MMM-YYYY');

        return (
            <h4 className="font-medium uppercase">
                COMMENCEMENT: {startDate} at {start.time} (SMT) <br />
                COMPLETION: {endDate} at {end.time} (SMT)
            </h4>
        );
    }

    function renderItem6() {
        return (
            <h4 className="font-medium uppercase">
                FUEL BUNKERED PORT: {record.item6.fuelBunkeredPort} <br />
                FUEL BUNKERED DATE:{' '}
                {moment(record.item6.fuelBunkeredDate, 'YYYY-MM-DD').format(
                    'DD-MMM-YYYY'
                )}{' '}
                <br />
                BDN NUMBER: {record.item6.bdnNumber} <br />
                BDN SULPHUR CONTENT: {record.item6.bdnSulphurContent} <br />
                QUANTITY BUNKERED: {record.item6.bunkeredQuantity}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupD1Preview;
